$('.land_video_content').slick({
  dots: true,
  infinite: true,
  autoplay: true,
  arrow: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  centerMode: true,
  centerPadding: '60px',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
$('.land_testimonials').slick({
  dots: true,
  infinite: true,
  autoplay: false,
  arrow: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  centerMode: true,
  centerPadding: '250px',

  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
$(document).ready(function () {
  jQuery(document).ready(function () {
    // Ensure all accordion text is hidden by default
    jQuery('.accordian-text').hide();

    jQuery('.accordian-title').click(function () {
      jQuery(this).siblings('.accordian-text').slideToggle();
      jQuery(this).toggleClass('contentOpen');
    });
  });
});


$(document).ready(function () {
  function slickMobile() {
    if ($(window).width() < 600) {   // Only mobile (<600px)
      if (!$('.land_pro_slide').hasClass('slick-initialized')) {
        $('.land_pro_slide').slick({
          dots: true,
          arrows: true,
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1
        });
      }
    } else {
      if ($('.land_pro_slide').hasClass('slick-initialized')) {
        $('.land_pro_slide').slick('unslick'); // Destroy on desktop/tablet
      }
    }
  }

  slickMobile(); // Run on load

  $(window).on('resize', function () {
    slickMobile(); // Run on resize
  });
});

// {% comment %} $(document).ready(function () {
//   $(".land_burger").click(function () {
//     $(".landing_menu").slideToggle(100);        // Toggle menu
//     $(this).toggleClass("active");              // Toggle active class on burger
//     $(".landing_menu").toggleClass("open");     // Optional: add class to menu too
//   });
// }); {% endcomment %}

// {% comment %} $(document).ready(function () {
//   $(".land_burger").click(function () {
//     $(".landing_menu").toggleClass("open");        // Toggle menu  // Optional: add class to menu too
//   });
// }); {% endcomment %}

jQuery(document).ready(function ($) {
  $(".land_burger").click(function () {
    $(".landing_menu").stop(true, true).slideToggle(500);
    $("landing_menu").addClass("open");
    $(this).toggleClass("open"); // optional if you want to style burger icon
  });
});